import classNames from 'classnames';
import { FC } from 'react';

import { IcDeleteIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import styles from './DeleteButton.styles.m.css';

interface IDeleteButtonProps {
  onClick(): void;
  className?: string;
}

export const DeleteButton: FC<IDeleteButtonProps> = ({ onClick, className }) => {
  return (
    <FAB
      className={classNames(styles.delete, className)}
      Icon={IcDeleteIcon}
      onClick={onClick}
      size="30"
      theme="12_1"
    />
  );
};
